import type { RepaymentForm } from "@loanlink-nl/model-app";

export const repaymentFormLabels = {
	annuity: "Annuïtair",
	"interest-only": "Aflossingsvrij",
	linear: "Lineair",
	"life-insurance": "Levensverzekering",
	"investment-mortgage": "Investeringshypotheek",
	"savings-mortgage": "Spaarrekening",
};

export const repaymentFormOptions: { value?: RepaymentForm; label: string }[] =
	[
		{ value: undefined, label: "selecteren..." },
		{ value: "annuity", label: repaymentFormLabels["annuity"] },
		{ value: "interest-only", label: repaymentFormLabels["interest-only"] },
		{ value: "linear", label: repaymentFormLabels["linear"] },
		{ value: "life-insurance", label: repaymentFormLabels["life-insurance"] },
		{
			value: "investment-mortgage",
			label: repaymentFormLabels["investment-mortgage"],
		},
		{
			value: "savings-mortgage",
			label: repaymentFormLabels["savings-mortgage"],
		},
	];
